// Owner gates (spec §1). Each flag is a publishing decision, not a feature toggle.
export const MK_FLAGS = {
  // G1 — APPROVED by the owner: Giorgi's name, photo and signature ship on the site.
  // Flip back together with founderPhoto.js (-> null) to render the team-signed fallback.
  FOUNDER_NOTE_APPROVED: true,
  // G2 — reviewer names as "First name + last initial". false renders "Google Play user".
  REVIEWER_NAMES_APPROVED: true,
  // G4 — show the default Google Play rating (4.5★, Sep 2026; owner-confirmed from Play Console). false swaps the
  // hero cell to "2016 / on Google Play since".
  SHOW_PLAY_RATING: true,
};
